import Box from 'components/shared/Box'
import Info from 'components/shared/Info'
import Text from 'components/shared/Text'
import { FormattedMessage } from 'react-intl'

export const VoucherFormHeader = () => (
    <Box direction="column" gap={12}>
        <Box direction="column" gap={8}>
            <Text variant="heading3" color="grayscale_900">
                <FormattedMessage
                    id="promo.march.voucher_form_header"
                    defaultMessage="Uzupełnij dane gości"
                />
            </Text>
            <Text variant="bodySmall" color="grayscale_800">
                <FormattedMessage
                    id="promo.march.voucher_form_description"
                    defaultMessage="Bilety i vouchery są imienne, więc koniecznie zabierz swój dowód tożsamości na obie wizyty!"
                />
            </Text>
        </Box>
        <Info color="info">
            <FormattedMessage
                id="promo.march.voucher_form_info_banner"
                defaultMessage="Upewnij się, że masz w koszyku wszystkie bilety, których potrzebujesz. Edytowanie zamówienia po wpisaniu danych oznacza konieczność wpisania danych ponownie."
            />
        </Info>
    </Box>
)
